<form [formGroup]="toolbarForm">
  <div class="form-row">
    <!--Only one Treatment Type for Deoxycholate-->
    <!-- <div class="form-group col">
      <label for="treatmentType">Treatment Type</label>
      <select class="form-control" formControlName="treatmentType" id="treatmentType">
        <option [ngValue]="treatmentTypes.Deoxycholate">{{ treatmentTypes.Deoxycholate }}</option>
      </select>
    </div> -->
    <ng-container formGroupName="observation">
      <!-- Deoxycholate -->
      <ng-container *ngIf="treatmentType === treatmentTypes.Deoxycholate">
        <ng-container formGroupName="details">
          <div class="form-group col">
            <label for="area">Area</label>
            <select class="form-control" formControlName="area" data-test-id="injectables-toolbar-area-select">
              <option *ngFor="let area of injectionFormService.deoxycholateAreas" [ngValue]="area.id">
                {{ area.name }}
              </option>
            </select>
          </div>
          <div class="form-group col">
            <label for="area">Clinic Supply</label>
            <select
              class="form-control"
              formControlName="injected"
              (change)="onObrListTypeSelected($event)"
              data-test-id="injectables-toolbar-toxin-select"
            >
              <ng-container *ngFor="let deoxycholate of injectionFormService.deoxycholates">
                <option [ngValue]="deoxycholate.id">
                  {{ deoxycholate.displayName }}
                </option>
              </ng-container>
            </select>
          </div>
        </ng-container>
        <div *ngIf="isInventoryRemainingDisplayed()" class="form-group col">
          <label for="inventory">Inventory</label>
          <input
            class="form-control text-white text-center w-100"
            name="inventory"
            disabled
            [ngClass]="{
              'bg-danger': getInventoryRemaining() <= 0 && getInventoryRemaining() !== null,
              'bg-success': getInventoryRemaining() > 0,
              'bg-white': getInventoryRemaining() === null
            }"
            [value]="getInventoryRemainingString()"
          />
        </div>
        <div class="form-group col">
          <label for="value">Amount (mL)</label>
          <input
            type="number"
            class="form-control w-100"
            data-test-id="injectables-toolbar-amount-input"
            formControlName="value"
            min="0"
            inputmode="numeric"
            RestrictDecimalPlacesNumber
            [nDecimalPlaces]="toolbarForm?.get('treatmentType')?.value === treatmentTypes.Toxins ? 1 : 2"
          />
        </div>
        <div class="form-group col">
          <label>Total</label>
          <div>{{ total }}</div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</form>
